import { NumberFormatter } from '@newo/ui-kit';

interface HoursRevenueProps {
    prefix?: string;
    wh: number;
    nwh: number;
}

const HoursRevenue = ({ wh, nwh, prefix }: HoursRevenueProps) => (
    <div className="text-xs text-gray-6 nw-format-number">
        <div className="flex justify-between mb-0.5">
            <span>Working Hours:</span>
            <NumberFormatter prefix={prefix} value={wh} />
        </div>
        <div className="flex justify-between">
            <span>Non-Working Hours:</span>
            <NumberFormatter prefix={prefix} value={nwh} />
        </div>
    </div>
);

export default HoursRevenue;
